import { render, staticRenderFns } from "./MaintenanceOrdersPage.vue?vue&type=template&id=3853bc7a"
import script from "./MaintenanceOrdersPage.vue?vue&type=script&lang=js"
export * from "./MaintenanceOrdersPage.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceOrdersPage.vue?vue&type=style&index=0&id=3853bc7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports